<script>
    import { navigate } from "svelte-routing";
    import { logged_in, show_sidebar } from "../../app-store";
    import { onMount } from "svelte";

    export let email;

    let otpInputs = Array(6).fill("");
    let isSubmitting = false;

    function handleInput(event, index) {
        const input = event.target;
        const value = input.value;

        // Only allow one character
        if (value.length > 1) {
            otpInputs[index] = value[0];
        }

        // Move to next input if value is entered
        if (value) {
            const nextInput = document.getElementById(`otp-${index + 2}`);
            if (nextInput && !nextInput.value) {
                nextInput.focus();
            }
        }
    }

    function handleKeyup(event, index) {
        // Move to previous input if backspace is pressed
        if (event.key === "Backspace") {
            const prevInput = document.getElementById(`otp-${index}`);
            if (prevInput) {
                prevInput.focus();
            }
        }
    }

    function handlePaste(event) {
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData).getData("text");
        const pasteValues = paste.split("");

        for (let i = 0; i < pasteValues.length && i < 6; i++) {
            if (/^\d$/.test(pasteValues[i])) {
                otpInputs[i] = pasteValues[i];
                const nextInput = document.getElementById(`otp-${i + 2}`);
                if (nextInput && i < 5) {
                    nextInput.focus();
                }
            }
        }
    }

    function validateOtp(value) {
        const reg = /^\d{1}$/;
        return reg.test(value);
    }

    async function handleSubmit() {
        // Validate all OTP inputs
        const isValid = otpInputs.every((value) => validateOtp(value));

        if (!isValid) {
            window.app.toast_msg.show("Invalid OTP");
            return;
        }

        const otp = otpInputs.join("");
        isSubmitting = true;

        try {
            const res = await window.app.lucep_ai.login(otp);
            if (res.status === "ok") {
                window.app.storage.set("creds", window.app.lucep_ai._creds);
                navigate("/project-list");
                logged_in.set(true);
                await window.app.init_sidebar_items();
            } else if (res.status === "register") {
                window.app.toast_msg.show("Contact the Lucep team");
            } else {
                window.app.toast_msg.show("Invalid OTP");
            }
        } catch (error) {
            console.error("Error during login:", error);
            window.app.toast_msg.show("Unable to login. " + error.msg);
        } finally {
            isSubmitting = false;
        }
    }

    onMount(() => {
        window.app.chat_manager.hide();
        window.app.lucep_ai.set_auth({ email: email });
    });
</script>

<div class="otp-container">
    <div class="otp-box panel">
        <h1 class="panel-title">Enter OTP</h1>
        <p class="panel-subtitle">Enter the OTP sent to {email}</p>

        <form class="otp-form" on:submit|preventDefault={handleSubmit}>
            <div class="otp-fields">
                {#each otpInputs as _, i}
                    <div class="field-otp-{i + 1}">
                        <input
                            id="otp-{i + 1}"
                            type="text"
                            maxlength="1"
                            size="1"
                            autocomplete="off"
                            bind:value={otpInputs[i]}
                            on:input={(e) => handleInput(e, i)}
                            on:keyup={(e) => handleKeyup(e, i + 1)}
                            on:paste={handlePaste}
                        />
                    </div>
                {/each}
            </div>
            <div class="field-btn-submit">
                <button id="btn-submit" type="submit" class="btn btn-primary btn-full-width" disabled={isSubmitting}>
                    {isSubmitting ? "" : "Submit"}
                    {#if isSubmitting}
                        <span class="spinner me-2"></span> Submitting...
                    {/if}
                </button>
            </div>
        </form>

        <button class="btn btn-link btn-resend-otp" type="button" on:click={() => navigate("/login")}>
            <small>Resend OTP or Change Email</small>
        </button>
    </div>
</div>

<style>
    .otp-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .otp-box {
        width: 100%;
        max-width: 400px;
        padding: 1rem;
    }

    .otp-fields {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 0.5rem;
		margin-bottom: 1rem;
    }

    input {
        width: 100%;
        height: 10vw;
        text-align: center;
        font-size: 1.2rem;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
	.btn {
		border-radius: 5px;
	}

    .btn-resend-otp {
        margin-top: 1rem;
        display: block;
        width: 100%;
    }

    .spinner {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        border-top-color: #fff;
        animation: spin 1s ease-in-out infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

	@media screen and (min-width: 576px) {
		input {
			height: 50px;
		}
	}
	@media screen and (min-width: 768px) {
		.otp-box {
			padding: 2rem;
		}
	}
</style>
